import { render, staticRenderFns } from "./ProcessStep.vue?vue&type=template&id=3bbb72aa&"
import script from "./ProcessStep.vue?vue&type=script&lang=js&"
export * from "./ProcessStep.vue?vue&type=script&lang=js&"
import style0 from "./ProcessStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports